export default __webpack_public_path__ + "static/media/travallo_4.7eb69b0e.png";